import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PluginComponent } from '../plugin.component';
import { Inspection } from '../../shared/models/index';
import { BasePlugin } from '../base-plugin.component';
import { TrainerPipe } from './trainer.pipe';
import * as _ from 'lodash';

@Component({
    templateUrl: './trainingproposals.component.html',
    standalone: false
})
export class TrainingProposalsPluginComponent extends BasePlugin implements OnInit {
  public plugin: any = {};
  inspectionId: string;
  public trainingProposals: any;
  public inspection: Inspection;

  constructor(private route: ActivatedRoute, private cdRef: ChangeDetectorRef, private trainerPipe: TrainerPipe) {
    super();
  }

  ngOnInit() {}

  config(
    plugin: any,
    inspection: Inspection,
    messages: Array<string>,
    showBreadcrumbs: boolean,
    showValidations: boolean,
    showContent: boolean
  ): void {
    super.config(plugin, inspection, messages, showBreadcrumbs, showValidations, showContent);
    this.trainingProposals = this.plugin.config.TrainingProposals.filter(
      (tp) => tp.Time || tp.Course || tp.Moment || tp.Trainees.length
    );
    this.cdRef.detectChanges();
  }

  getEditRoute() {
    return [this.inspectionsRoute, this.inspection.id, 'plugins', this.plugin.id, 'trainingproposals', 'edit'];
  }

  public getSelectedValues(items: any): string {
    const values = _.map(items, (item: any) => this.trainerPipe.transform(item));
    return values.length > 0 ? values.join('<br/>') : '';
  }
}

PluginComponent.plugins['trainingproposals'] = TrainingProposalsPluginComponent;
